export const printStyledJson = (title: string, jsonObject: any): void => {
	console.groupCollapsed(
		`%c ${title} `,
		'background: #222; color: #bada55; font-weight: bold; font-size: 16px; padding: 4px; border-radius: 3px;'
	)
	console.dir(jsonObject, { colors: true, depth: null })
	console.groupEnd()
}
